module.exports = __webpack_public_path__ + "static/media/mobile-money.14690e54.svg";